module.exports = __webpack_public_path__ + "assets/img/arrow_right.cc678c77.png";